import { CurrencyCodeEnum } from '@/enums'
import {
  BalanceReportData,
  BalanceReportResponse,
  GetBalanceReportPayload,
} from '../models'

/**
 * TEMPORARY MOCK
 * ==============
 * The `balance-report` endpoint does not exist on casino-auth yet. While the
 * backend is built in parallel, this flag makes the page fully demoable with
 * local fixture data. Flip `USE_BALANCE_REPORT_MOCK` to `false` (or wire it to
 * an env var) once the real endpoint is available.
 */
export const USE_BALANCE_REPORT_MOCK = false

const CURRENCIES = [
  CurrencyCodeEnum.USD,
  CurrencyCodeEnum.EUR,
  CurrencyCodeEnum.MXN,
]

/**
 * Deterministic fixture: players that currently have a balance.
 */
const MOCK_PLAYERS: BalanceReportData[] = Array.from({ length: 47 }).map(
  (_, index) => {
    const bet = Math.round((1500 + index * 237.5) * 100) / 100
    const win = Math.round((1200 + index * 198.25) * 100) / 100
    const daysAgo = index % 30

    const lastDayPlayed = new Date()
    lastDayPlayed.setDate(lastDayPlayed.getDate() - daysAgo)

    return {
      playerId: 100000 + index,
      username: `player_${100000 + index}`,
      balance: Math.round((50 + index * 73.42) * 100) / 100,
      currency: CURRENCIES[index % CURRENCIES.length],
      lastDayPlayed: lastDayPlayed.toISOString(),
      lifetimeBet: bet,
      lifetimeWin: win,
      lifetimeWL: Math.round((bet - win) * 100) / 100,
    }
  },
)

/**
 * Mimics the paginated backend response, honoring the playerId and
 * last-day-played date filters so the UI filters work in the demo.
 */
export const getBalanceReportMock = (
  payload: GetBalanceReportPayload,
): BalanceReportResponse => {
  const { playerId, startDate, endDate, page = 1, limit = 25, xlsx } = payload

  let filtered = [...MOCK_PLAYERS]

  if (playerId) {
    filtered = filtered.filter((player) =>
      player.playerId.toString().includes(playerId.toString()),
    )
  }

  if (startDate) {
    const from = new Date(startDate).getTime()
    filtered = filtered.filter(
      (player) => new Date(player.lastDayPlayed).getTime() >= from,
    )
  }

  if (endDate) {
    const to = new Date(endDate).getTime()
    filtered = filtered.filter(
      (player) => new Date(player.lastDayPlayed).getTime() <= to,
    )
  }

  const total = filtered.length
  const pages = Math.max(1, Math.ceil(total / limit))
  const docs = xlsx
    ? filtered
    : filtered.slice((page - 1) * limit, (page - 1) * limit + limit)

  return {
    status: 200,
    docs,
    total,
    pages,
    page,
    limit,
  }
}
